import Figura from './Figura';
import { sobre } from '../data/contenido';
import { retratoValentina } from '../data/fotos';

export default function Sobre() {
  return (
    <section className="sobre" id="sobre">
      <div className="envoltura">
        <div className="sobre__grilla">
          <Figura className="sobre__figura" foto={retratoValentina} />
          <div className="sobre__texto">
            <div className="cabecera" data-reveal="">
              <p className="rotulo">Quien está detrás</p>
              <h2 className="titulo">{sobre.titulo}</h2>
            </div>
            {sobre.parrafos.map((parrafo, i) => (
              <p key={parrafo.slice(0, 24)} data-reveal="" style={{ '--retraso': `${120 + i * 90}ms` }}>
                {parrafo}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
